<template>
    <section
        class="flex flex-col justify-center items-center flex-grow p-5 md:pb-16 md:p-8"
    >
        <slot></slot>
    </section>
</template>
